import { Login } from "../../components/auth/login";
import { Card } from "react-bootstrap";

const LoginPage = () => {

  const cardStyle = {
    width: '500px',
    border: 'none',
    marginTop: '35px',
    background: 'transparent',
  };

  const cardStyleM = {
    width: '100%',
    border: 'none',
    marginTop: '35px',
    background: 'transparent',
  };


  return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center qw-pc">
          <h1 className="bold">DAXIL <span className="text-gradient">OL</span></h1>
          <Card style={cardStyle}>
            <Card.Body>
                <div>
                    <Card.Text>
                      <Login />
                    </Card.Text>
                </div>
            </Card.Body>
          </Card>
        </div>

        <div className="text-center qw-mobile">
          <h1 className="bold">DAXIL <span className="text-gradient">OL</span></h1>
          <Card style={cardStyleM}>
            <Card.Body>
                <div>
                    <Card.Text>
                      <Login />
                    </Card.Text>
                </div>
            </Card.Body>
          </Card>
        </div>
      </div>
  );
};

export default LoginPage;